import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getFavoriteAdvertList, getFavoriteListFilter, getPriceHistoryByAdvert } from "./Services";




export const useGetFavoriteList = () => {

  const query = useQuery(
    [endpoints.getFavoriteListFilter],
    () => {
      return getFavoriteListFilter();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};


export const useGetFavoriteAdvertList = (listId:string) => {

  const query = useQuery(
    [endpoints.getFavoriteAdvertList,listId],
    () => {
      return getFavoriteAdvertList(listId);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};

export const useGetAdvertPriceHistories= (advertId:string) => {

  const query = useQuery(
    [endpoints.getPriceHistoryByAdvert,advertId],
    () => {
      return getPriceHistoryByAdvert(advertId);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};
